export class DTOResetPassword {
    Email: string;
    ResetPasswordToken: string;
    NewPassword: string;
}
